import { GoalEventDataPoint } from '../../coaching-commitment/models/goal-event-data-point.model';
import { GoalHistoryDataPointsResponse } from '../../coaching-commitment/models/goal-history-data-points-response.model';
import { MetricDataItem } from '../../insight/performance-data/metric.pd.model';
import { createAction } from '../../store.model';
import { PeriodType } from '../../widget/date-range.widget.model';

import { ChartType } from './chart-type.model';

export enum ActionType {
    COACHING_DETAIL__P3__RELOAD_CHART = 'COACHING_DETAIL__P3__RELOAD_CHART',
    COACHING_DETAIL__P3__RELOAD_CHART_RESUlT = 'COACHING_DETAIL__P3__RELOAD_CHART_RESUlT',
    COACHING_DETAIL__P3__RELOAD_CHART_CANCEL = 'COACHING_DETAIL__P3__RELOAD_CHART_CANCEL',
    COACHING_DETAIL__P3__RELOAD_DETAIL = 'COACHING_DETAIL__P3__RELOAD_DETAIL',
    COACHING_DETAIL__P3__RELOAD_DETAIL_RESUlT = 'COACHING_DETAIL__P3__RELOAD_DETAIL_RESUlT',
    COACHING_DETAIL__P3__RELOAD_DETAIL_CANCEL = 'COACHING_DETAIL__P3__RELOAD_DETAIL_CANCEL',
    COACHING_DETAIL__P3__SELECT_CHART = 'COACHING_DETAIL__P3__SELECT_CHART',
}

export interface ReloadChart {
    userId: number;
    chartType: ChartType;
    periodTypeId: PeriodType;
    metricId: number;
    commitmentId: number;
    goalId: number;
}

export const reloadChart = createAction<ActionType, ReloadChart>(
    ActionType.COACHING_DETAIL__P3__RELOAD_CHART,
);

export interface ReloadChartResult extends ReloadChart {
    userSg?: MetricDataItem[];
    sg?: MetricDataItem[];
    goalHistory?: GoalHistoryDataPointsResponse;
    goalEventHistory?: GoalEventDataPoint[];
}

export const reloadChartResult = createAction<ActionType, ReloadChartResult>(
    ActionType.COACHING_DETAIL__P3__RELOAD_CHART_RESUlT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ReloadChartCancel {}

export const reloadChartCancel = createAction<ActionType, ReloadChartCancel>(
    ActionType.COACHING_DETAIL__P3__RELOAD_CHART_CANCEL,
);

/// ///////

export interface ReloadDetail {
    userId: number;
    periodTypeId: PeriodType;
    metricId: number;
}

export const reloadDetail = createAction<ActionType, ReloadDetail>(
    ActionType.COACHING_DETAIL__P3__RELOAD_DETAIL,
);

export interface ReloadDetailResult extends ReloadDetail {
    dates?: Array<{ startDate: Date; endDate: Date }>;
    data?: MetricDataItem[][];
}

export const reloadDetailResult = createAction<ActionType, ReloadDetailResult>(
    ActionType.COACHING_DETAIL__P3__RELOAD_DETAIL_RESUlT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ReloadDetailCancel {}

export const reloadDetailCancel = createAction<ActionType, ReloadDetailCancel>(
    ActionType.COACHING_DETAIL__P3__RELOAD_DETAIL_CANCEL,
);

/// ///////

export interface SelectChart {
    chartType: ChartType;
    periodTypeId: PeriodType;
}

/** also acts as a means to reset data */
export const selectChart = createAction<ActionType, SelectChart>(
    ActionType.COACHING_DETAIL__P3__SELECT_CHART,
);
